var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// elements/components/x-flex.ts
import { customElement } from "lit/decorators.js";
import { ChemistryLiteElement } from "../../chemistry-lite-element.js";
import { paddingAndMarginAttributes, withVariableAttribute } from "../token-helpers.js";
var XFlex = class extends ChemistryLiteElement {
  styles() {
    return [
      {
        display: "flex",
        ...withVariableAttribute("space", Object.keys(this.spacing ?? {}), (size) => ({
          gap: this.spacing?.[size]
        })),
        "&:not([horizontal])": { flexDirection: "column" },
        "&[reverse]": {
          flexDirection: "column-reverse",
          "&[horizontal]": { flexDirection: "row-reverse" }
        },
        "&[horizontal]": { flexDirection: "row" },
        ...paddingAndMarginAttributes(this.spacing ?? {}),
        "& > [flex]": { flex: "1" },
        "& > [flex-none]": { flexShrink: 0, flexGrow: 0, flexBasis: "auto" },
        "&[crossaxis-start]": { alignItems: "flex-start" },
        "&[crossaxis-center]": { alignItems: "center" },
        "&[crossaxis-end]": { alignItems: "flex-end" },
        "&[crossaxis-stretch]": { alignItems: "stretch" },
        "&[start]": { justifyContent: "flex-start" },
        "&[center]": { justifyContent: "center" },
        "&[end]": { justifyContent: "flex-end" },
        "&[space-between]": { justifyContent: "space-between" },
        "&[space-around]": { justifyContent: "space-around" },
        "&[wrap]": { flexWrap: "wrap" },
        "&[wrap-reverse]": { flexWrap: "wrap-reverse" },
        "&[h100]": { height: "100%" },
        "&[w100]": { width: "100%" }
      }
    ];
  }
};
XFlex = __decorateClass([
  customElement("x-flex")
], XFlex);
export {
  XFlex
};
